import { render } from "./TurnoverSettingForm.vue?vue&type=template&id=34a864ce"
import script from "./TurnoverSettingForm.vue?vue&type=script&lang=js"
export * from "./TurnoverSettingForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__